module.exports = __webpack_public_path__ + "img/sld_abt_meter_b1_dark.9d92d78b.svg";